
export const navigationMain = [
  {
    name: 'navigation',
    path: '/navigation',
    meta: {
      title: '导航网站',
      icon: 'shezhi'
    }
  },
  {
    name: 'navigationSet',
    path: '/navigation/set',
    component: () => import('/@/views/plugins/navigation/Set.vue'),
    meta: { title: '基本设置' }
  },
  {
    name: 'navigationCategory',
    path: '/navigation/category',
    component: () => import('/@/views/plugins/navigation/Category.vue'),
    meta: { title: '导航分类' }
  },
  {
    name: 'navigationList',
    path: '/navigation/list',
    component: () => import('/@/views/plugins/navigation/List.vue'),
    meta: { title: '数据管理' }
  }
]

